import { Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { Login } from './pages/Login'
import { Register } from './pages/Register'
import { Dashboard } from './pages/Dashboard'
import { Businesses } from './pages/Businesses'
import { BusinessDetail } from './pages/BusinessDetail'
import { Services } from './pages/Services'
import { Staff } from './pages/Staff'
import { Bookings } from './pages/Bookings'
import { Events } from './pages/Events'
import { Subscription } from './pages/Subscription'
import { Profile } from './pages/Profile'
import { PublicBusiness } from './pages/PublicBusiness'
import { MyBookings } from './pages/MyBookings'
import { Reminders } from './pages/Reminders'
import { Availability } from './pages/Availability'

export default function App() {
  return (
    <Routes>
      {/* Página pública por negocio */}
      <Route path="/b/:slug" element={<PublicBusiness />} />
      <Route path="/mis-inscripciones" element={<MyBookings />} />
      <Route path="/reminders" element={<Reminders />} />

      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/businesses" element={<Businesses />} />
          <Route path="/businesses/:id" element={<BusinessDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/events" element={<Events />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/availability" element={<Availability />} />
        </Route>
      </Route>
    </Routes>
  )
}
